import { gql } from "apollo-boost"

export const GET_PROJECT_BENEFICIARIES_WITH_ACTIVITIES = gql`
  query ProjectBeneficiariesWithActivities(
    $submissionId: ID!
  ){
    ProjectBeneficiariesWithActivities(
      submissionId: $submissionId
    )
  }
  `